import React from "react";

const AboutCareer = () => {
  return (
    <div className="hardware-container">
      <div className="content">
        <h2 className="heading"><span>CAREER</span></h2>
        <p className="description">
          No learning curve is fundamental for expertist
        </p>

        <div className="horizontal-text-container">
          <p>About Us</p>
          <p>/</p>
          <p>Career</p>
        </div>
      </div>
    </div>
  );
};

export default AboutCareer;
